module.exports = __webpack_public_path__ + "img/home-sidebar-logged-in.272d7cb5.jpg";